import React from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import BaseMatManModal from '@monorepo/shared/src/components/common/Modals/BaseMatManModal';
import BaseModalTitle from '@monorepo/shared/src/components/common/Modals/BaseModalTitle';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import useAssignments from 'state/hooks/use-assignments';

const tAssignment = (key, options?) => translate('assignment', key, options);

const AssignLetterFooter: React.FC = () => {
  const classes = useStyles();
  const [{ hasUnsavedChanges }, { handleExit, handleNewAssignmentSave }] = useAssignments();
  const [, { openModal, closeModal }] = useModal();
  const { letter } = useParams();
  const letters = `${letter?.toUpperCase()}${letter?.toLowerCase()}`;

  const handleSave = () => {
    openModal({
      Title: () => (
        <BaseModalTitle
          text={tAssignment('assignSpecificLetter', { letters })}
          onClose={closeModal}
        />
      ),
      body: (
        <BaseMatManModal
          leftButtonAction={closeModal}
          rightButtonAction={handleNewAssignmentSave}
          headerText={`${tAssignment('assignSpecificLetter', { letters })}?`}
          headerFontSize={'24px'}
          leftButtonText={tAssignment('noCancel')}
          rightButtonText={tAssignment('assignLetter')}
        >
          <Box>
            <Typography variant="subtitle1">
              {tAssignment('createAssignmentBody', { letters })}
            </Typography>
          </Box>
        </BaseMatManModal>
      ),
    });
  };

  return (
    <Paper className={classes.container}>
      <ButtonWithFontAwesome
        className={classes.button}
        onClick={handleExit}
        text={tAssignment('cancelAssignment')}
        aria-label={tAssignment('cancelAssignment')}
        variant="outlined"
        color="primary"
      />
      <ButtonWithFontAwesome
        className={classes.button}
        startIcon={faArrowRight}
        onClick={handleSave}
        text={tAssignment('assignLetter')}
        aria-label={tAssignment('assignLetter')}
        variant="contained"
        color="primary"
        disabled={!hasUnsavedChanges}
        size="sm"
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    height: 60,
    position: 'fixed',
    left: 0,
    bottom: 0,
    right: 0,
  },
  button: {
    margin: '10px 30px',
  },
}));
export default AssignLetterFooter;
